import { render, staticRenderFns } from "./ModalAddYear.vue?vue&type=template&id=c131eb02&lang=pug&"
import script from "./ModalAddYear.vue?vue&type=script&lang=js&"
export * from "./ModalAddYear.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddYear.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports